import { useEffect, useState } from 'react';
import throttle from 'lodash.throttle';

const useScrollThrottled = (
  callback: (args: {
    previousScrollPosition: number;
    currentScrollTop: number;
  }) => void
) => {
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);

  const handleScroll = () => {
    const { scrollTop: currentScrollTop } =
      document.documentElement || document.body;

    if (previousScrollPosition >= 0 && currentScrollTop >= 0) {
      callback({ previousScrollPosition, currentScrollTop });
    }

    setPreviousScrollPosition(currentScrollTop);
  };

  const handleScrollThrottled = throttle(handleScroll, 250);

  useEffect(() => {
    window.addEventListener('scroll', handleScrollThrottled);

    return () => window.removeEventListener('scroll', handleScrollThrottled);
  }, [handleScrollThrottled]);
};

export default useScrollThrottled;
